import { z } from 'zod'

import UiKitCard from '@nxt-insurance/ui-kit/components/cards/Card'

import type { HorizontalAlignment } from '@/cms/helperTypes'
import { borderRadiusUnion, colorEnum, spaceUnion } from '@/cms/helperTypes'
import { BlockContent } from '@/components/renderers/BlockContent'
import type { PortableTextTypeComponentProps } from '@portabletext/react'
import { BORDER_RADIUS } from '@ui-kit/constants'

const CARD_WIDTH = 400

const card = z.object({
  _type: z.literal('card'),
  backgroundColor: colorEnum.optional(),
  borderColor: z.enum([...colorEnum.options, 'none']).optional(),
  content: z.array(z.unknown()),
  maxCardWidth: z.number().optional(),
  verticalPadding: spaceUnion.optional(),
  horizontalPadding: spaceUnion.optional(),
  borderRadius: borderRadiusUnion.optional(),
})

export const Card = (props: {
  node: PortableTextTypeComponentProps<unknown>
  sectionName: string
  align: HorizontalAlignment
}) => {
  const value = card.parse(props.node.value)
  if (!value.content) {
    return null
  }

  return (
    <UiKitCard
      bgColor={value.backgroundColor ?? undefined}
      borderColor={value.borderColor ?? undefined}
      verticalPadding={value.verticalPadding ?? undefined}
      horizontalPadding={value.horizontalPadding ?? undefined}
      style={{
        maxWidth: value.maxCardWidth ?? CARD_WIDTH,
        borderRadius: BORDER_RADIUS[value.borderRadius ?? 'normal'],
        width: '100%',
      }}
    >
      <BlockContent
        blocks={value.content}
        width={CARD_WIDTH}
        align={props.align}
        sectionName={props.sectionName}
      />
    </UiKitCard>
  )
}
